
import { List, Popup, Icon } from 'vant';
import { getTime } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';


export default {
  name: 'home',
  components: {
    [List.name]: List,
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  data () {
    return {
      // 用户头像
      userHeadUrl: require('../../../assets/images/ic_head.png'),
      // 用户昵称
      userWxName: '',
      // 当前IMEI
      nowImei: '',
      // 当前ICCID
      nowIccid: '',
      // 加载状态
      loadingSimCard: true,
      // 当前SIM卡是否是小镜卡
      simIsXjCard: true,
      // 当前SIM状态
      simStateText: '',
      // 当前套餐到期时间
      nowMealEndTime: '',
      // 套餐列表
      simMealList: [],
      // 显示购买记录
      showPurchase: false,
      purchaseList: []
    }
  },
  methods: {
    // 获取当前SIM卡信息
    getSimCardInfoFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/sim/card/getSimCardInfo', { iccid: this.$store.state.nowIccid })
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.loadingSimCard = false;
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            _this.simIsXjCard = resData.isXJCard;
            // 判断是否是小镜卡
            if (resData && resData.isXJCard) {
              // 获取套餐列表
              _this.getMealListFn();
              // 当前SIM卡信息
              // 当前SIM卡信息-到期时间
              _this.nowMealEndTime = getTime.getFormatDate(1, resData.stop_time);
              // 当前SIM卡信息-SIM卡状态
              let simStateText = '';
              if (resData.forbid_type === 1) {
                simStateText = '封停';
              } else if (resData.status === 1) {
                simStateText = '已激活';
              } else if (resData.status === 2) {
                simStateText = '已停用';
              } else if (resData.status === 0) {
                simStateText = '未激活';
              } else {
                simStateText = 'SIM卡异常';
              }
              _this.simStateText = simStateText;
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取套餐列表失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 231);
        })
    },
    // 获取套餐列表
    getMealListFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/sim/pkg/getBuyablePkgList', {})
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            if (resData && resData.length > 0) {
              // 计算每天的均价
              for (let i = 0; i < resData.length; i++) {
                // 后台的价格是以分为单位
                let price = resData[i].price / 100;
                let dayNumber = 1;
                if (resData[i].valid_type === 'Y') {
                  dayNumber = parseInt(resData[i].valid_time) * 365;
                } else if (resData[i].valid_type === 'M') {
                  dayNumber = parseInt(resData[i].valid_time) * 30;
                } else if (resData[i].valid_type === 'D') {
                  dayNumber = parseInt(resData[i].valid_time);
                } else if (resData[i].valid_type === 'H') {
                  dayNumber = parseInt(resData[i].valid_time) / 24;
                }
                resData[i].pre = (price / dayNumber).toFixed(2);
              }
              // 赋值
              _this.simMealList = resData;
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取套餐列表失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 232);
        })
    },
    // 获取已购买套餐(购买记录)列表
    getPurchaseMealListFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/sim/pkg/getMyPkgList', { iccid: this.$store.state.nowIccid })
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data.data;
            if (resData && resData.length > 0) {
              for (let j = 0; j < resData.length; j++) {
                let effectiveText = 1;
                if (resData[j].valid_type === 'Y') {
                  effectiveText = resData[j].valid_time + '年';
                } else if (resData[j].valid_type === 'M') {
                  effectiveText = resData[j].valid_time + '个月';
                } else if (resData[j].valid_type === 'D') {
                  effectiveText = resData[j].valid_time + '天';
                } else if (resData[j].valid_type === 'H') {
                  effectiveText = resData[j].valid_time + '小时';
                }
                resData[j].buyTime = getTime.getFormatDate(2, resData[j].buy_time);
                resData[j].effectiveText = effectiveText;
                resData[j].mobileText = resData[j].mobile.substring(0, 3) + '*****' + resData[j].mobile.substring(8, 11);
              }
              _this.purchaseList = resData;
            }
            // 打开弹出层
            _this.showPurchase = true;
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '查询购买记录失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 233);
        })
    },
    // 查询购买记录
    showPurchaseFn () {
      // 获取已购买套餐
      this.getPurchaseMealListFn();
    },
    // 点击遮罩层时触发
    clickOverlay () {

    },
    closePopupFn () {
      this.showPurchase = false;
      this.clickOverlay();
    },
    // 购买套餐 确认
    buyPackagesFn (packageId, title) {
      this.$dialog.confirm({
        title: '',
        message: '你确定要购买 ' + title + ' 吗？'
      }).then(() => {
        // on confirm
        this.buyPackagesSubmitFn(packageId);
      }).catch(() => {
        // on cancel
      });
    },
    // 购买套餐
    buyPackagesSubmitFn (packageId) {
      if (!packageId) {
        return this.$toast('套餐ID错误');
      }
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/sim/pkg/createSimPkgOrder', {
        iccid: this.$store.state.nowIccid,
        customer: this.$store.state.customer,
        payType: 'wechat', // 表示微信支付
        src: 'wx', // 表示是公众号发起的订单
        packageId: packageId, // 套餐ID
      })
        .then(function (response) {
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            try {
              if (WeixinJSBridge) {
                _this.buyPackagesPayFn(resData);
              }
            } catch (err) {
              return _this.$toast('请在微信公众号上操作！');
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '购买套餐失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 234);
        })
    },
    // 购买套餐 发起支付
    buyPackagesPayFn (payData) {
      let _this = this;
      WeixinJSBridge.invoke('getBrandWCPayRequest', payData, function(res){
        if(res.err_msg === 'get_brand_wcpay_request:ok' ) {
          // success
          // 刷新当前SIM卡信息
          _this.getSimCardInfoFn();
          _this.$dialog({
            message: '恭喜您，流量套餐购买成功！'
          })
        } else {
          _this.$dialog({
            message: '很遗憾，支付失败（235）'
          })
        }
      });
    },
  },
  created () {
    window.scrollTo(0,0);
    this.nowImei = this.$store.state.nowImei;
    this.nowIccid = this.$store.state.nowIccid;
    // 获取当前SIM卡信息
    if (this.$store.state.nowIccid) {
      this.getSimCardInfoFn();
    }
    // 用户头像和昵称
    if (this.$store.state.wxInfo) {
      this.userHeadUrl = this.$store.state.wxInfo.headurl;
      this.userWxName = this.$store.state.wxInfo.nickname;
    }
  }
}
